import { createCustomEnum } from "../customEnum";

export type AchProcessorType = "straddle";

export const AchProcessorTypes = createCustomEnum({
	Straddle: {
		value: 0,
		name: "straddle",
		displayName: "Straddle",
	},
});
